/*! moodicon-title v1 – gemeinsame Titel-Logik für Grid & PDP */
(function(root){
  function normalizeHex(h){
    if(!h) return '';
    let s = String(h).trim().toUpperCase();
    if (s.startsWith('U+')) s = s.slice(2);
    s = s.replace(/[^0-9A-F\-]/g,'');
    s = s.split('-')[0].replace(/FE0F$/,'');
    return /^[0-9A-F]{4,6}$/.test(s) ? s : '';
  }

  function getEmojiName(hex, locale){
    try{
      if (root.MoodiconData && MoodiconData.util && typeof MoodiconData.util.emojiName === 'function'){
        return MoodiconData.util.emojiName(hex, { locale: locale || 'de' }) || '';
      }
    }catch(_){}
    // Fallback: Hex wenn kein Name verfügbar
    return normalizeHex(hex) || '';
  }

  var SEP = ' \u00B7 '; // ·

  function titleFor(opts){
    var isReal    = !!(opts && opts.isReal);
    var realTitle = (opts && opts.realTitle) || '';
    var baseTitle = (opts && opts.baseTitle) || '';
    var hex       = (opts && opts.hex)       || '';
    var sep       = (opts && typeof opts.sep === 'string') ? opts.sep : SEP;
    var locale    = (opts && opts.locale) || 'de';

    if (isReal) return realTitle;
    var name = getEmojiName(hex, locale);
    return (name ? name : hex) + sep + baseTitle;
  }

  root.MoodiconTitle = { titleFor, getEmojiName, SEP };
})(this);

